var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 300,
    viewBox: "0 0 233 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.955078,
    y: -34.0078,
    width: 44.9905,
    height: 411.144,
    transform: "rotate(-27.7961 0.955078 -34.0078)",
    fill: "#AD2F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleImg);
export default __webpack_public_path__ + "static/media/RectangleImg.93d5a37cedb68691e29da8ba3cc144b3.svg";
export { ForwardRef as ReactComponent };